module.exports = __webpack_public_path__ + "static/media/clave.49adfd0d.wav";